__turbopack_context__.v({
  "root": "TotalBalanceSlider-module-scss-module__pkMZaq__root",
  "rootMargin": "TotalBalanceSlider-module-scss-module__pkMZaq__rootMargin",
});
